module.exports = __webpack_public_path__ + "static/media/malini.0da48aa5.jpg";